import { FC, useState, useRef, useEffect, memo, useLayoutEffect } from "react";
import { BsChevronDown, BsCheckLg } from "react-icons/bs";
import { createPortal } from "react-dom";
import classes from "./style.module.scss";
import { CSSProperties } from "styled-components";
import SearchBox from "../../components-library/searchbox";

type TOnoSelect = {
  options: Array<{
    label: string;
    value: string;
    disabled?: boolean;
    image?: string;
    textColor?: string;
    required?: boolean;
    id?: number;
    shortName?: string;
    disburse?: boolean;
  }>;
  value?: string | number;
  lable?: string;
  styles?: CSSProperties;
  onChange?: (selectedOption: { label: string; value: string }) => void;
  classNames?: string;
  starMark?: boolean;
  fromSupplyDemand?: boolean;
  paymentMargin?: boolean;
  required?: boolean;
  disabled?: boolean;
};

export const OnoSelect: FC<TOnoSelect> = ({
  options,
  value = "",
  lable = "",
  onChange,
  classNames,
  starMark,
  fromSupplyDemand,
  styles = {},
  paymentMargin = false,
  required,
  disabled = false,
}) => {
  const ref = useRef<HTMLElement>(null);
  const optionsRef = useRef<HTMLUListElement>(null);
  const [dropUp, setDropUp] = useState<boolean>(false);
  const [display, setDisplay] = useState(false);
  const [selectedOption, setSelectedOption] = useState({
    label: "",
    value: "",
    disabled: false,
    image: "",
    textColor: "",
    id: 0,
    shortName: "",
  });
  const [position, setPosition] = useState({
    left: 0,
    top: 0,
    width: 0,
    height: 0,
    bottom: 0,
  });
  const onSelect = (option: {
    label: string;
    value: string;
    disabled?: boolean;
  }) => {
    if (!option.disabled) {
      onChange && onChange(option);
      setDisplay(false);
      setSearchTerm("");
    }
  };
  useEffect(() => {
    if (value) {
      let sel_option = {
        label: "",
        value: "",
        disabled: false,
        image: "",
        textColor: "",
        id: 0,
        shortName: "",
      };
      for (let option of options) {
        if (option.value === value && !option.disabled) {
          sel_option = {
            label: option.label,
            value: option.value,
            disabled: option.disabled!,
            image: option.image!,
            textColor: option.textColor!,
            id: option.id!,
            shortName: option.shortName!,
          };
          break;
        }
      }
      setSelectedOption(sel_option);
    } else {
      setSelectedOption({
        label: "",
        value: "",
        disabled: false,
        image: "",
        textColor: "",
        id: 0,
        shortName: "",
      });
    }
  }, [value, options]);

  const toggleDropdown = () => {
    if (!display) updateDropdownPosition();
    setDisplay(!display);
    setSearchTerm("");
  };

  const updateDropdownPosition = () => {
    const rect = ref.current?.getBoundingClientRect();
    if (!rect) return;

    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;

    const itemHeight = 40;
    const contentHeight = options.length * itemHeight;
    const dropdownHeight = Math.min(contentHeight, 240);

    const shouldDropUp = spaceBelow < dropdownHeight && spaceAbove > spaceBelow;

    setDropUp(shouldDropUp);

    setPosition({
      top: shouldDropUp ? rect.top - dropdownHeight : rect.bottom,
      left: rect.left,
      width: rect.width,
      height: dropdownHeight,
      bottom: rect.bottom,
    });
  };

  useLayoutEffect(() => {
    if (display) updateDropdownPosition();
  }, [display]);

  const [searchTerm, setSearchTerm] = useState("");

  const filteredOptions = options.filter((option) =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <div
        className={classNames}
        style={{ height: fromSupplyDemand ? "100%" : "auto" }}
      >
        <div className={`${paymentMargin ? "mb-2" : ""}`}>
          <label className="font-semibold text-sm">
            {lable} {required && <span className="color-red">*</span>}
          </label>
        </div>

        <button
          className={`${paymentMargin ? "py-[2px]" : "h-full"
            } w-full rounded-lg bg-white border-gray ${disabled ? "opacity-50 cursor-not-allowed" : ""
            }`}
          disabled={disabled || selectedOption?.disabled}
        >
          <span
            className={`flex w-full h-full items-center br-10 py-2 ${classes.selectbox
              } ${disabled ? "bg-[#F4F4F4] cursor-not-allowed" : "cursor-pointer"
              }`}
            ref={ref}
            onClick={() => {
              if (!disabled) toggleDropdown();
            }}
            style={styles}
          >
            <span className="flex items-center pr-1">
              {selectedOption.image && (
                <img
                  src={selectedOption.image}
                  className="w-5 h-5 mr-1"
                  alt=""
                />
              )}
              <span className={`${selectedOption.textColor}`}>
                {selectedOption.label || " Select "}
              </span>
            </span>
            <BsChevronDown className={`ml-auto color-gray`} />
          </span>
        </button>
      </div>
      {display === true &&
        createPortal(
          <>
            <div
              onClick={() => {
                setDisplay(false);
              }}
              className="fixed h-full w-full top-0 left-0"
              style={{ zIndex: "110" }}
            ></div>
            <ul
              ref={optionsRef}
              className={`shadow-md ${classes.selectUl}`}
              style={{
                position: "fixed",
                top: position.top,
                left: position.left,
                width: position.width + 20,
                maxHeight: 240,
                overflowY: "auto",
                zIndex: 120,
              }}
            >
              <div className="sticky top-0 bg-white p-2">
                <SearchBox
                  value={searchTerm}
                  placeholder="search..."
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>

              {filteredOptions?.map((option) => (
                <li
                  className={`flex px-4 py-3 text-sm items-center `}
                  data-value={option.value}
                  data-selected={
                    option.value === value && !option.disabled ? true : false
                  }
                  data-disabled={option.disabled}
                  onClick={() => {
                    onSelect(option);
                  }}
                >
                  {option.image && (
                    <img src={option.image} className="w-5 h-5 mr-1" alt="" />
                  )}
                  <span
                    className={`${option.value === value &&
                      option.label === "Processed" &&
                      !option.disabled
                      ? "text-white"
                      : option.textColor
                      }`}
                  >
                    {option.label}
                    {option.shortName ? ` (${option.shortName}) ` : ""}
                  </span>
                  {option.value === value && <BsCheckLg className="ml-auto" />}
                </li>
              ))}
            </ul>
          </>,
          document.body,
        )}
    </>
  );
};

export default memo(OnoSelect);
